export default {"src":"/_next/static/media/logo-vale.b2824d47.svg","height":56,"width":148};